import { renderSlot as _renderSlot, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dashboards-charts__chart" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardsCalendar = _resolveComponent("DashboardsCalendar")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["dashboards-charts", { 'dashboards-charts--full-calendar': !_ctx.isChartVisible }])
  }, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "chart", {}, undefined, true)
    ], 512), [
      [_vShow, _ctx.isChartVisible]
    ]),
    _createVNode(_component_DashboardsCalendar, {
      params: _ctx.calendarParams,
      isDense: _ctx.isChartVisible,
      dateNavigation: _ctx.isChartVisible ? undefined : _ctx.threeMonthsNavigationDate
    }, null, 8, ["params", "isDense", "dateNavigation"])
  ], 2))
}